var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center"},[_c('div',{staticClass:"w-full px-3 py-6 max-w-6xl xl:w-3/4"},[_c('UserProfileForm',{attrs:{"title":"Editar Perfil","user-id":_vm.state.user.id,"profile":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }